<!-- Invoice Charges Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <h3 class="fw-bold m-0">Invoice Charges Management</h3>
    </div>
    <div class="card-toolbar">
      <!-- Base Toolbar -->
      <div class="d-flex justify-content-end" data-kt-invoice-charge-table-toolbar="base">
        <!-- Filter Button -->
        <button type="button" class="btn btn-sm btn-light-primary me-3" (click)="toggleFilters()">
          <i class="ki-duotone ki-filter fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Filter
        </button>

        <!-- Add Invoice Charge Button -->
        <button type="button" class="btn btn-sm btn-primary" (click)="openAddInvoiceChargeModal()">
          <i class="ki-duotone ki-plus fs-2"></i>
          Add Invoice Charge
        </button>
      </div>

      <!-- Selected Toolbar -->
      <div class="d-flex justify-content-end align-items-center d-none" data-kt-invoice-charge-table-toolbar="selected">
        <div class="fw-bold me-5">
          <span class="me-2">{{ selectedInvoiceCharges.length }}</span>Selected
        </div>
        <button type="button" class="btn btn-sm btn-danger" (click)="bulkDeleteInvoiceCharges()">
          Delete Selected
        </button>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Filters Form -->
    <div *ngIf="showFiltersForm" class="mb-5" [@fadeIn]>
      <div class="card bg-light">
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-4">
              <label class="form-label">Search</label>
              <input
                type="text"
                class="form-control form-control-sm"
                [(ngModel)]="searchTerm"
                placeholder="Search invoice charges..."
              />
            </div>
            <div class="col-md-12">
              <button type="button" class="btn btn-sm btn-primary me-2" (click)="applyFilters()">
                Apply Filters
              </button>
              <button type="button" class="btn btn-sm btn-secondary" (click)="resetFilters()">
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="text-center py-10">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!isLoading && invoiceCharges.length === 0" class="text-center py-10">
      <div class="mb-5">
        <i class="ki-duotone ki-file-deleted fs-5x text-muted">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
      </div>
      <h3 class="text-muted">No invoice charges found</h3>
      <p class="text-muted">Start by adding your first invoice charge</p>
    </div>

    <!-- Data Table -->
    <div *ngIf="!isLoading && invoiceCharges.length > 0" class="table-responsive">
      <table class="table align-middle table-row-dashed fs-6 gy-5" id="kt_invoice_charges_table">
        <thead>
          <tr class="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
            <th class="w-25px text-center">
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [checked]="isAllSelected()"
                  [indeterminate]="isIndeterminate()"
                  (change)="toggleAllSelection($event)">
              </div>
            </th>
            <th class="min-w-125px">Name</th>
            <th class="text-end min-w-100px">Value in USD</th>
            <th class="text-end min-w-100px">Value in JPY</th>
            <th class="text-end min-w-100px">Actions</th>
          </tr>
        </thead>
        <tbody class="text-gray-600 fw-semibold">
          <tr *ngFor="let invoiceCharge of invoiceCharges; trackBy: trackByFn">
            <td class="text-center pe-0">
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [value]="invoiceCharge._id"
                  [checked]="isSelected(invoiceCharge._id)"
                  (change)="toggleSelection(invoiceCharge._id, $event)">
              </div>
            </td>
            <td class="ps-2">
              <div class="d-flex align-items-center">
                <div class="d-flex justify-content-start flex-column">
                  <span class="text-dark fw-bold text-hover-primary fs-6">{{ invoiceCharge.label || 'N/A' }}</span>
                </div>
              </div>
            </td>
            <td class="text-end">
              <span class="text-dark fw-bold">{{ invoiceCharge.usd || 0 | number:'1.2-2' }}</span>
            </td>
            <td class="text-end">
              <span class="text-dark fw-bold">{{ invoiceCharge.jpy || 0 | number:'1.2-2' }}</span>
            </td>
            <td class="text-end">
              <div class="d-flex justify-content-end gap-2">
                <!-- Edit Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-primary"
                  (click)="openEditModal(invoiceCharge)"
                  title="Edit Invoice Charge">
                  <i class="ki-duotone ki-pencil fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Delete Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-danger"
                  (click)="deleteInvoiceCharge(invoiceCharge)"
                  title="Delete Invoice Charge">
                  <i class="ki-duotone ki-trash fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                    <span class="path5"></span>
                  </i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div *ngIf="!isLoading && invoiceCharges.length > 0">
      <app-pagination
        [paginationInfo]="paginationInfo"
        [loading]="isLoading"
        (pageChange)="onPageChange($event)">
      </app-pagination>
    </div>
  </div>
</div>

<!-- Invoice Charge Add/Edit Modal -->
<app-add-edit-invoice-charge
  (invoiceChargeAdded)="onInvoiceChargeAdded()"
  (invoiceChargeUpdated)="onInvoiceChargeUpdated()">
</app-add-edit-invoice-charge>
